export default __webpack_public_path__ + "static/media/paywayLogoColor.f38d0550.png";